export default __webpack_public_path__ + "static/1-web-server-3edc7d64437aeed2116ff819898d2d4d.png";